import Cookies from "js-cookie";
import { ElMessage, ElLoading } from 'element-plus'
const isAppTag = Cookies.get("is-app");
export const isIos = () => isAppTag == 1;
export const isAndroid = () => isAppTag == 2;
export const isApp = () => isIos() || isAndroid();

export const getAppData = () => {
  if (!isApp()) {
    return;
  }

  const deviceType = Cookies.get("device-type");
  const deviceId = Cookies.get("device-id");
  const Authorization = Cookies.get("access_token");
  return {
    deviceType,
    deviceId,
    Authorization,
  };
};

let callbackIdIndex = 0;
export const callNativeFn = (options = {}) => {
  return new Promise((resolve, reject) => {
    // methodName: String, //调用函数名
    // callbackId: String, //js异步调用native回调id
    // responseId: String, //native回调js 调用id
    // data: T  //传递参数
    const { methodName } = options;
    callbackIdIndex++;

    const callbackId = `${new Date().getTime()}_${callbackIdIndex}`;
    const callbackIdName = `${methodName}_${callbackId}`;

    window.callH5Callback[callbackIdName] = (callbackData = {}) => {
      resolve(callbackData);
    };

    Object.assign(options, {
      callbackId,
    });
    console.log("options", options);

    try {
      if (isIos()) {
        webkit.messageHandlers.jsToNative.postMessage({
          command: "callNative",
          func: options.methodName, // 调用ios函数
          callbackId: options.callbackId,
          params: options.data,
        });
      } else if (isAndroid()) {
        renheAppBridge.callNative(JSON.stringify(options));
      }
    } catch (e) {
      console.log(e);
      reject(e);
    }
  });
};

export const callH5Init = () => {
  if (window.callH5Callback) {
    return;
  }

  window.callH5Callback = {};

  window.callH5 = (callbackData = {}) => {
    try {
      callbackData = JSON.parse(callbackData);
    } catch (e) {}

    const { methodName, responseId } = callbackData;
    const callbackIdName = `${methodName}_${responseId}`;

    try {
      window.callH5Callback[callbackIdName](callbackData);
    } catch (e) {
      console.log(e);
    }
  };
};
